import { render, staticRenderFns } from "./Talk2.vue?vue&type=template&id=02f30df0&scoped=true"
import script from "./Talk2.vue?vue&type=script&lang=js"
export * from "./Talk2.vue?vue&type=script&lang=js"
import style0 from "./Talk2.vue?vue&type=style&index=0&id=02f30df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f30df0",
  null
  
)

export default component.exports